import * as React from "react";
import { Link } from "react-router-dom";

export type SectionMore = {
    link?: string;
    text?: string;
    action?: () => void;
};

export interface SectionHeaderProps {
    children: React.ReactNode;
    more?: SectionMore;
}

export interface SectionProps {}

class Section extends React.Component<SectionProps & React.ComponentProps<"section">, {}> {
    static Header = ({
        children,
        more,
        className = "",
        ...others
    }: SectionHeaderProps & React.HTMLProps<HTMLDivElement>) => (
        <header
            {...others}
            className={`flex w-full grow-0  items-center justify-between ${className}`}
        >
            <div className="flex grow items-center justify-between">{children}</div>

            {more?.link && <Link to={more.link}>{more.text || "More"}</Link>}

            {typeof more?.action === "function" && (
                <a
                    href="#more"
                    role="button"
                    onClick={(e) => {
                        e.preventDefault();
                        more.action?.();
                    }}
                >
                    {more.text || "More"}
                </a>
            )}
        </header>
    );

    static Content = ({ children, className = "", style = {} }: {
        children: React.ReactNode;
        className?: string;
        style?: React.CSSProperties;
    }) => (
        <main className={`w-full grow overflow-hidden ${className}`} style={style}>
            {children}
        </main>
    );

    render() {
        const { className = "", children, ...others } = this.props;

        return (
            <section
                className={`flex flex-col space-y-4 rounded-r10 bg-black90 px-4 py-3 ${className}`}
                {...others}
            >
                {children}
            </section>
        );
    }
}

export default Section;
